<section class="faq">
  <div class="faq-title">
    <h2>{{ "Frequently Asked Questions" | translate }}</h2>
    <p>{{ "faq subtitle" | translate }}</p>
  </div>

  <div class="faq-answerAsk">
    <div class="leftSide faq-answerAsk-item">
      <div class="numberText">
        <span class="counter number">1236</span>
        <span class="text">{{ "Tours Completed" | translate }}</span>
      </div>

      <div class="numberText">
        <span class="counter number">6183</span>
        <span class="text">{{ "Happy Tourists" | translate }}</span>
      </div>

      <div class="numberText">
        <span class="counter number">{{ appStateService.tours.length }}</span>
        <span class="text">{{ "Tours In Armenia" | translate }}</span>
      </div>

      <div class="numberText">
        <span class="number number">{{ yearsOfExperiance }}</span>
        <span class="text">{{ "Year Of Experience" | translate }}</span>
      </div>
    </div>

    <div class="rightSide faq-answerAsk-item">
      <div class="texts">
        <span class="title">{{ "own tour" | translate }}</span>
        <span class="subTitle">{{ "own tour answer" | translate }}</span>
      </div>

      <div class="texts">
        <span class="title">{{ "tour type question" | translate }}</span>
        <span class="subTitle">{{ "tour type answer" | translate }}</span>
      </div>

      <div class="texts">
        <span class="title">{{ "driver speak" | translate }}</span>
        <span class="subTitle">{{ "driver speak answer" | translate }}</span>
      </div>
    </div>
  </div>
</section>
